import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getLoyaltyMetrics = {
  name: "getLoyaltyMetrics" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    totalMembers: z.number(),
    totalPointsIssued: z.number(),
    pointsRedeemed: z.number(),
    valueRedeemed: z.string(),
  }),
};
